export default __webpack_public_path__ + "static/building-relationship-10d64faeca743192e846ce2fbcc906e2.gif";